/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ActivityPageThreadedFeedInternalRequest} from '@cash-web/protos/squareup/cash/activity/api/v1/service.pb'
import {ActivityPageThreadedFeedInternalResponse} from '@cash-web/protos/squareup/cash/activity/api/v1/service.pb'


export const activityPageThreadedFeedInternal = (request:ActivityPageThreadedFeedInternalRequest, options?: CashRequestOptions) => post<ActivityPageThreadedFeedInternalRequest, ActivityPageThreadedFeedInternalResponse>("/2.0/cash/activity-page-threaded-feed-internal", request, {...options, rejectOnError: true })